import React from 'react'
import AuditTrailsTable from '../../common/AuditTrailsTable';
import { GetCopyIntakeAuditTrialCancelToken, GetCopyIntakeAuditTrialDropdownCancelToken, getCopyIntakeAuditTrial, getCopyIntakeAuditTrialDropdown } from '../../../services/copyIntakeServices';
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';

function AuditTrails() {
  usePermissionGuardRedirect(['intakeCopyView']);

  const columnsToShow = ["Action Type", "Resource Name"]

  return (
    <AuditTrailsTable
      apiFunction={GetCopyIntakeAuditTrialCancelToken}
      apiParams={{}}
      columnsToShow={columnsToShow}
      filterArrApi={GetCopyIntakeAuditTrialDropdownCancelToken}
      // actionId={id}
      exportFileName={"Intake_copy_auditTrail"}
      // resourceNameRedirect={handleRedirect}
      isResourceNameShown={true}
    />
  )
}

export default AuditTrails